/**
 * DevExtreme (esm/__internal/ui/text_box/m_text_editor.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../../core/component_registrator";
import TextEditorMask from "./m_text_editor.mask";
registerComponent("dxTextEditor", TextEditorMask);
export default TextEditorMask;
